<mat-form-field #formFieldContainer floatLabel="always" class="avl-trace-wrapper">
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div style="width: 100%; height: 100%;  overflow: hidden;" [style.height.px]="mapHeight">
        <div #targetMap [id]="fieldName+'map'" class="map" style="height: 100%;">
            <div id="info" class="popover"
                [style.left]="infoPosition.left" [style.top]="infoPosition.top"
                [style.display]="isPopoverOpen? 'table': 'none'">
                <div class="popover-inner">
                    <div #tooltipInfo class="popup-content"></div>
                </div>
            </div>
            <div #container id="popup" class="ol-popup">
                <div #content id="popup-content"></div>
            </div>
        </div>
    </div>

    <div #containerChart id="chart" style="width: 100%;" [ngClass]="disabled ? 'disable-element' : ''"></div>

    <!-- TO DO : <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display> -->
</mat-form-field>
